export default [
  {
    path: '/bons-transferts',
    name: 'bon-transfert-list',
    props: true,
    component: () => import('@/views/transferVouchers/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des bons de transfert',
      pageDesc: 'Consultez, filtrez et gérez les bons de transfert logistiques. Accédez aux détails, créez ou validez des transferts pour une gestion efficace des mouvements de colis.',
      accessibility: {
        ariaLabel: 'Liste des bons de transfert logistiques',
        breadcrumbLabel: 'Fil d’Ariane des bons de transfert',
      },
      breadcrumb: [
        {
          text: 'Bons de transfert',
          to: { name: 'bon-transfert-list' },
          ariaLabel: 'Accueil des bons de transfert',
        },
        {
          text: 'Liste des bons de transfert',
          active: true,
          ariaLabel: 'Liste des bons de transfert',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-transferts/reception-central',
    name: 'reception-transfert',
    props: true,
    component: () => import('@/views/transferVouchers/Reception.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Réception des colis transférés',
      pageDesc: 'Scannez et validez la réception des colis transférés entre dépôts logistiques.',
      accessibility: {
        ariaLabel: 'Réception des colis transférés',
        breadcrumbLabel: 'Fil d’Ariane réception transfert',
      },
      breadcrumb: [
        {
          text: 'Réception des transferts',
          to: { name: 'reception-transfert' },
          ariaLabel: 'Accueil réception transfert',
        },
        {
          text: 'Réception des colis transférés',
          active: true,
          ariaLabel: 'Réception des colis transférés',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-transferts/create',
    name: 'bon-transfert-add',
    props: true,
    component: () => import('@/views/transferVouchers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Créer un bon de transfert',
      pageDesc: 'Créez un nouveau bon de transfert en sélectionnant les colis et les dépôts concernés.',
      accessibility: {
        ariaLabel: 'Création d’un bon de transfert logistique',
        breadcrumbLabel: 'Fil d’Ariane création bon de transfert',
      },
      breadcrumb: [
        {
          text: 'Bons de transfert',
          to: { name: 'bon-transfert-list' },
          ariaLabel: 'Accueil des bons de transfert',
        },
        {
          text: 'Créer un bon de transfert',
          active: true,
          ariaLabel: 'Créer un bon de transfert',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/bons-transferts/show/:id',
    name: 'bon-transfert-show',
    props: true,
    component: () => import('@/views/transferVouchers/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageDesc: 'Consultez les informations détaillées du bon de transfert, y compris les colis, dépôts, livreurs et statuts associés.',
      accessibility: {
        ariaLabel: 'Détails du bon de transfert logistique',
        breadcrumbLabel: 'Fil d’Ariane détails bon de transfert',
      },
      breadcrumb: [
        {
          text: 'Bons de transfert',
          to: { name: 'bon-transfert-list' },
          ariaLabel: 'Accueil des bons de transfert',
        },
        {
          text: 'Détails du bon de transfert',
          active: true,
          ariaLabel: 'Détails du bon de transfert',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
]
